<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Add Expenses</h6>
             </div>
             
             <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add Expenses</a>
         </div>
         
         <div class="card p-4">
            <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 lg:space-x-4">
                <!-- Start Date -->
                <div class="w-full lg:w-auto">
                    <label for="startDate" class="block text-sm font-medium text-gray-700 ">From Date</label>
                    <input 
                        type="date" 
                        id="startDate" 
                        v-model="startDate" 
                        class="w-full p-2 border border-gray-300 rounded " 
                    />
                </div>
        
                <!-- End Date -->
                <div class="w-full lg:w-auto">
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">To Date</label>
                    <input 
                        type="date" 
                        id="endDate" 
                        v-model="endDate" 
                        class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded " 
                    />
                </div>
                  <div class="w-full lg:w-auto ml-3 mb-4"   >
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">Search Ledger</label>
                     <select class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded" id="ledger_name" ref="ledger_name" v-model="sale.selected_leadgerId">
                     
                        <option value="0">ALL</option>
                        <option v-for="(item, index) in ledgerList" :key="index" :value="item.id">
                            {{ item.name }}
                          </option>
                    </select>
                    <div> {{ (selected_leadger)?'Cash Balance : '+selected_leadger.blalancecash+'  Bank Balance : '+selected_leadger.blalancebank:'' }} </div>
                </div>


                <div class="w-full lg:w-auto ml-3 mb-4" style="width: 150px;">
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">Search Group</label>
                     <select class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded" id="group_name" ref="group_name" v-model="sale.selected_groupId">
                     
                        <option value="0">ALL</option>
                        <option v-for="(item, index) in  groupList" :key="index" :value="item.id">{{ item.groupname }}</option>
                    </select>
                    
                </div>

                <!-- Filter Button -->
                <div class="w-full lg:w-auto flex justify-center lg:justify-start">
                    <button 
                        type="submit" 
                        @click="getBasics" 
                        class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer"
                    >
                        Filter
                    </button>
                </div> 
                
                <div class="w-full lg:w-auto ml-3 mb-4" style="width: 150px;">
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">Search Payment Type</label>
                     <select class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded" id="payment_type" ref="payment_type" v-model="sale.selected_payment_type">
                     
                        <option value="0">ALL</option>
                        <option v-for="(item, index) in  payementtype" :key="index" :value="item.paymenttype">{{ item.paymenttype }}</option>
                    </select>
                    
                </div>





            </div>
            

    <!-- Vendor Filter: Branch -->
    <!--<div class="w-full lg:w-auto" style="width: 250px;">-->
    <!--    <label for="ledger_name" class="block text-sm font-medium text-gray-700">Search Ledger</label>-->
    <!--    <select class="form-input w-full p-2 border border-gray-300 rounded" id="ledger_name" ref="ledger_name" v-model="sale.selected_leadgerId">-->
    <!--        <option value=""></option>-->
    <!--        <option value="All">ALL</option>-->
    <!--        <option v-for="(item, index) in  ledgerList" :key="index" :value="item.id">{{ item.name }}</option>-->
    <!--    </select>-->
    <!--</div>-->


        </div>




         <!--<div class="card">-->
                <!-- Static heading -->
         <!--       <div id="printable-content">-->
         <!--           <h1 class="print-only" style="text-align: center;">Zambre Patil Prayog Parivar</h1>-->
         <!--           <h1 class="print-only" style="text-align: center;">Expenses Report</h1>-->
         <!--       </div>-->
         <!--       <div class="printfix">From {{startDate}} To {{endDate}}</div>-->
         <!--       <button-->
         <!--           type="reset"-->
         <!--           @click="printReceipt"-->
         <!--           class="btn b-light btn-danger-light btn-sm"-->
         <!--       >-->
         <!--           Print-->
         <!--       </button>-->
         <!--       </div>-->
        
<!-- Start All Language List Table -->
<div class="p-3 sm:p-4">
    <div class="overflow-x-auto scrollbar-table">
        <table id="languageTable" class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
            <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                <tr>
                    <th class="px-3.5 py-4">Tr. ID</th>
                    <th class="px-3.5 py-4">Entry Date</th>
                    <th class="px-3.5 py-4">Voucher No</th>
                    <th class="px-3.5 py-4">Ledger Name</th>
                    <th class="px-3.5 py-4">Party</th>
                    <th class="px-3.5 py-4">Group</th>
                    <th class="px-3.5 py-4">Address</th>
                    <th class="px-3.5 py-4">Mobile No</th>
                    <th class="px-3.5 py-4">Particular</th>
                    <th class="px-3.5 py-4">Payment Type</th>
                    <th class="px-3.5 py-4">Payment Details</th>
                    <th class="px-3.5 py-4">Total Amount</th>
                    <th class="px-3.5 py-4">Action</th>
                </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item, index) in catList" :key="item.id">
                      <td class="px-3.5 py-4">{{ item.id }}</td>
                    <td class="px-3.5 py-4">
                        {{ (item.entry_date) }}
                      </td>
                    <td class="px-3.5 py-4">{{ item.vnumber }}</td>
                    <td class="px-3.5 py-4">{{ item.ledger_name }}</td>
                    <td class="px-3.5 py-4">{{ item.party }}</td>
                    <td class="px-3.5 py-4" @click="filterByGroup(item.groupname)">{{ item.groupname }} / {{ item.choice }}</td>
                    <td class="px-3.5 py-4">{{ item.address }}</td>
                    <td class="px-3.5 py-4">{{ item.mobileno }}</td>
                    <td class="px-3.5 py-4">{{ item.particular }}</td>
                    <td class="px-3.5 py-4">{{ item.paymenttype}}</td>
                    <td class="px-3.5 py-4">{{ item.paymentdetails}}</td>
                    <td class="px-3.5 py-4">{{ item.totalamount }}</td>
                    <td class="px-3.5 py-4">
                        <div class="flex items-center gap-1">
                            <button class="btn-icon btn-primary-icon-light size-7" @click="editModal(item)">
                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                            </button>
                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)">
                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                  <td colspan="11" class="font-bold text-right">Total:</td>
                  <td class="font-bold">{{ totalamount }}</td>
                </tr>
              </tfoot>

        </table>
    </div>
</div>
<!-- End All Language List Table -->

     </div>
 </div>
 <!-- End Main Content -->





<!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full h-screen bg-black bg-opacity-50">
    <div class="p-4 w-full max-w-lg overflow-hidden">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square h-full flex flex-col">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            
            <div class="p-4 md:p-5 overflow-y-auto">
           

                <div class="mt-7 grid grid-cols-2 gap-4">
                    <!-- Left Column -->
                    <div>
                        <label for="tagname" class="form-label">SELECT LEDGER *</label>
                        <select v-model="cat.ledgerid" class="form-input">
                            <option disabled value="0">SELECT LEDGER</option>
                            <template v-for="(item, index) in ledgerList" :value="item.id">
                                    <option :value=" item.id"  >{{ item.name }}</option>
                            </template>
                        </select>
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Voucher No *</label>
                        <input type="number" v-model="cat.vnumber" class="form-input" placeholder="Voucher No" autocomplete="off" required>
                    </div>

                    <!-- Right Column -->
                    <div>
                        <label for="tagname" class="form-label">Party *</label>
                        <input 
                            type="text" 
                            v-model="cat.party" 
                            class="form-input" 
                            placeholder="Party" 
                            autocomplete="off" 
                            required
                            @input="filterSuggestions"
                        >
                        <ul v-if="filteredSuggestions.length" class="suggestions-list">
                            <li v-for="suggestion in filteredSuggestions" @click="selectSuggestion(suggestion)">
                                {{ suggestion.name }}
                            </li>
                        </ul>
                    </div>
                    

                    <div>
                        <label for="tagname" class="form-label">SELECT GROUP *</label>
                        <select v-model="cat.groupid" class="form-input">
                            <option disabled value="0">SELECT GROUP</option>
                            <option v-for="(item, index) in addgroupList" :value="item.id">  {{ item.groupname }} / {{ item.choice }}</option>
                        </select>
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Address *</label>
                        <input type="text" v-model="cat.address" class="form-input" placeholder="Address" autocomplete="off" required>
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Mobile No *</label>
                        <input type="number" v-model="cat.mobileno" class="form-input" placeholder="Mobile No" autocomplete="off" required>
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Particular *</label>
                        <input type="text" v-model="cat.particular" class="form-input" placeholder="Particular" autocomplete="off" required>
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Paymnt Type *</label>
                        <select   v-model="cat.paymenttype" class="form-input">
                            <option value="Upi">Upi</option>
                            <option value="Cheque">Cheque</option>
                            <option value="NEFTI">NEFTI</option>
                            <option value="Cash">Cash</option>
                        </select>
            
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Payment Details *</label>
                        <input type="text" v-model="cat.paymentdetails" class="form-input" placeholder="Payment Details" autocomplete="off" required>
                    </div>

                    <div>
                        <label for="tagname" class="form-label">Total Amount *</label>
                        <input type="number" v-model="cat.totalamount" class="form-input" placeholder="Total Amount" autocomplete="off" required>
                    </div>

                   <div>
                    <label>Date : <input type="date" v-model="cat.entry_date"></label>
                     <lable class="color">Date:DD/MM/YYYY</lable>
                    </div>

                </div>
            </div>
            <div class="flex justify-end p-4">
                <button @click="save_category" v-show="showSaveBtn" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
            </div>
        </div>
    </div>
</div>



 <!-- Start Delete Modal -->
 <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-md max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             <div class="p-4 md:p-5 text-center">
                 <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                 <div class="mt-5 text-center">
                     <h5 class="mb-1">Are you sure?</h5>
                     <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                     <div class="flex justify-center gap-2 mt-6">
                         <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                         <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
 <!-- End Delete Modal -->
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'ProductCategory',
components: {
 
} ,
mounted(){
  this.getLeadgers();
},

data() {
    const today = new Date().toISOString().split('T')[0];
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId:0,
     startDate: this.getStartDate(),//new Date(Date.now() - 7 * 86400000).toISOString().split('T')[0],
     endDate: today,
    //  isTableVisible: false, 
     ledgerList:[],
     lastrecord:[],
     selected_leadgerId:0,
     selected_groupId:0,
     addgroupList:[],
     original_catList:[],
     currentStock:0,
     groupList:[],
     payementtype:[],
     filteredGroup: null,  // New property to store filtered group
     catList:[],
     original_catList:[],
     sale: {
        ledger_name: null,
        payment_type:'',
     },
     selected_leadger:null,
     showSaveBtn:true,
     allSuggestions: [], // Example suggestions
      filteredSuggestions: [],
     cat:{ledgerid:'',vnumber:'',party:'',groupid:'',address:'',mobileno:'',particular:'',totalamount:'',entry_date:this.todayDate(),paymenttype:'',paymentdetails:''},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }

 
 }, 

 computed: {
    totalamount() {
        return this.catList.reduce(
            (total, item) => total + (parseFloat(item.totalamount) || 0), 0
        );
    },
},



methods:{


 closeModal(){
     
         $("#editModal").addClass('hidden');
         $("#deleteModal").addClass('hidden');
     this.isAdd=0;
     this.isEdit=0;
     this.isDelete=0;
     this.deleteId=0;
 },
 getStartDate() {
      let startDate = new Date(Date.now() - 275 * 86400000);
      startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },
 formatDate(date) {
      const formattedDate = new Date(date);
      const day = String(formattedDate.getDate()).padStart(2, '0');
      const month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
      const year = formattedDate.getFullYear();
      return `${day}-${month}-${year}`;
    },
 todayDate()
    {
        const dateObj = new Date();
        var month=dateObj.getMonth()+1;
        var day=dateObj.getDate();
        const currentDate = dateObj.getFullYear()+"-"+((month<10)?'0'+month:month)+"-"+((day<10)?'0'+day:day);
        return currentDate;
    },

    
    filterSuggestions() {
    var self = this;
    // if(this.allSuggestions && this.allSuggestions.length>0)
    this.filteredSuggestions = this.cat.party
        ? this.allSuggestions
            .filter(suggestion => suggestion.name.toLowerCase().includes(self.cat.party.toLowerCase()))
            .map(suggestion => ({ name: suggestion.name, address: suggestion.address,contact: suggestion.contact}))  // Select both 'name' and 'address' properties
        : [];
},




    selectSuggestion(suggestion) {
      this.cat.party = suggestion.name;;
      this.cat.address= suggestion.address;
      this.cat.mobileno= suggestion.contact;
      this.filteredSuggestions = [];
      
    },

//     selectSuggestion(suggestionName) {
//     this.cat.address = suggestionName;  // Attach selected name to the address field
// },



 filterByGroup(groupName) {
        if (this.filteredGroup === groupName) {
            // If already filtered by the same group, reset filter
            this.filteredGroup = null;
            this.getBasics();  // Re-fetch all expenses
        } else {
            // Filter by the selected group
            this.filteredGroup = groupName;
            this.catList = this.catList.filter(item => item.groupname === groupName);
        }
    },

    
 addModal(){
    this.cat = {
  ledgerid: this.selected_leadgerId || null,
  vnumber:'' ,
  party: '',
  groupid: this.lastrecord?.groupid || null,
  mobileno: '',
  particular: '',
  totalamount: '',
  entry_date: this.todayDate(),
  paymenttype:'',
  paymentdetails:'',
};    
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 deleteModal(id){
     this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
  async getLeadgers() {
       var self=this;
         axios.post('getleger',{fromdate:self.startDate,todate:self.endDate}).then(function (response) {
             
                 if ($.fn.dataTable.isDataTable('#languageTable')) {
                        $('#languageTable').DataTable().destroy();
                    }
                 
                                             
               self.ledgerList = response.data.getleger;
               self.addgroupList = response.data.getleger;
               self.allSuggestions=response.data.partylist;
               self.addgroupList = response.data.addgrouplist;
               self.groupList=response.data.grouplist;
               self.payementtype=response.data.paymentType;
             //  self.filteredSuggestions=self.allSuggestions;
         }).then(()=>{
                      
                        $("#ledger_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Ledger Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) { 
                                            self.selected_leadger=self.ledgerList.filter(item => item.id== event.target.value)[0];
                                            console.log(self.selected_leadger);
                                            self.selected_leadgerId=event.target.value;   
                                            self.cat.ledgerid=self.selected_leadgerId;

                                        });



                                        $("#group_name").select2({
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Group Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) { 

                                        self.selected_groupId=event.target.value;   
                                        self.cat.groupid=self.selected_groupId;

                                        });


                                       
                                        $("#payment_type").select2({
                                            
                                        width: '80%',
                                        dropdownAutoWidth : true,
                                        placeholder:"Search Payment Type Here...",
                                    "language": {
                                                "noResults": function(){
                                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                                }
                                            },
                                                escapeMarkup: function (markup) {
                                                    return markup;
                                                }
                                    }).on('change', function (event) { 
                                         self.catList.slice(0); 
                                        if ($.fn.dataTable.isDataTable('#languageTable')) {
                                                $('#languageTable').DataTable().destroy();
                                            }
                                            if(event.target.value && event.target.value!="ALL") {
                                                self.catList=self.original_catList.filter(item => item.paymenttype == event.target.value);
                                               
                                            }else{
                                                 self.catList=self.original_catList;
                                            }    
                                            if(self.catList && self.catList.length>0){
                                                self.$nextTick(() => { self.refreshDatatble();});
                                            }
                                            // self.$nextTick(() => {
                                            // 
                                            // });

                                        });








 
                     
                         self.refreshDatatble();
                });   
         
         },
         
    refreshDatatble() {
       
            $('#languageTable').DataTable( {
                dom: 'Bfrtip',
                buttons: [
                    'print',
                    'excelHtml5',
                    'csvHtml5',
                    'pdfHtml5'
                ]
            } );
                                         
              
         },
 async getBasics() {



       var self=this;

         axios.post('getexpenses',{fromdate:self.startDate,todate:self.endDate,selected_leadgerId:self.selected_leadgerId,selected_groupId:self.selected_groupId}).then(function (response) {
             
                 if ($.fn.dataTable.isDataTable('#languageTable')) {
                        $('#languageTable').DataTable().destroy();
                    }
                 
                                             
               //self.ledgerList = response.data.ledgerlist;
               self.addgroupList = response.data.addgrouplist;
               self.catList=response.data.getAllexpenses;
               self.original_catList=response.data.getAllexpenses;
               self.allSuggestions=response.data.getAllparty;
               self.employees=response.data.userDetails;
               self.lastrecord=response.data.modeldataload;
               self.original_catList=response.data.getAllexpenses;
               self.payementtype=response.data.paymentType;
            
               
                }).then(()=>{
                        // self.cat.ledgerid=self.lastrecord.ledgerid;
                        // self.cat.groupid=self.lastrecord.groupid;
                      
                     
                        self.refreshDatatble();
                });
  },

  save_category() {
             var self = this; 

              // Check if ledgerid is empty, null, or undefined
                if (!self.cat.ledgerid) {
                    self.$swal("Please Select ledger...");
                    return; // Stop further execution if validation fails
                }
        else{
             self.showSaveBtn=false;
             axios.post('addexpenses', this.cat)
                 .then(response => {
                     
                    self.showSaveBtn=true;
                    if ($.fn.dataTable.isDataTable('#languageTable')) {
                                                $('#languageTable').DataTable().destroy();
                                            }
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                     
                     self.catList=response.data.cats;
                     self.employees=response.data.userDetails;
                    //  self.cat={name:'',status:'Active'};
                    // self.getBasics();  
                     self.closeModal();
                     //self.$swal(msg);
                     if (isSuccess == 1) {
                         self.closeModal();
                     }
                 }).then(()=>{
                self.refreshDatatble();
                })
                 .catch(error => {
                    self.showSaveBtn=true;
                     console.log('Error on Authentication: ' + error);
                 });
                }
         },
         delete_category() {
             var self = this; 
             axios.post('deleteexpenses', {deleteId:this.deleteId,selected_leadgerId:self.selected_leadgerId})
                 .then(response => {
                   if ($.fn.dataTable.isDataTable('#languageTable')) {
                                                $('#languageTable').DataTable().destroy();
                                            }
                     self.catList=response.data.cats;
                     self.employees=response.data.userDetails; 
                    self.closeModal(); 
                   // self.getBasics();
            }).then(()=>{
                self.refreshDatatble();
                })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
         printReceipt() {
            $('.datatable').DataTable().destroy(); 
             window.print();
    },







}
}



</script>

<style>
    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}
</style>


<style scoped>
    tfoot{
        background: antiquewhite;
        font-size: medium;
        font-weight: 800;
    }
    tfoot td{
        height: 35px;
    }
    .print-only {
        display: none;
    }
    
    @media print {
        .print-only {
            display: block; /* Show elements for print */
            text-align: center; /* Center alignment as needed */
            font-size: 16px; /* Font size adjustments if needed */
        }
    }
    
    
    @media print {
        /* Hide unnecessary elements */
        button, select, input, h2, .header_class, .header, .card-title {
            display: none !important;
        }
        
    
        /* Adjust the layout */
        body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
        }
    
        /* Receipt container */
        .receipt-container, #printable-content {
            width: 100%;
            padding: 10mm;
            margin: auto;
            border: 1px solid #000;
        }
    
        /* Add a border and spacing to the table */
        table {
            width: 100%;
            border-collapse: collapse;
        }
    
        table th, table td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
            font-size: 12px;
            color: black !important; 
        }
    
        
        table th {
            background-color: #f2f2f2;
            font-weight: bold;
            color: black!important;
        }
    
        /* Center titles */
        h1, h2 {
            text-align: center;
            margin: 0 0 10px;
            font-size: 16px;
            font-weight: bold;
        }
    
        /* Add company branding details */
        #printable-content {
            text-align: center;
        }
    
        #printable-content h1 {
            font-size: 20px;
        }
    
        /* Add spacing between sections */
        .section {
            margin-bottom: 20px;
        }
    
        /* Performance container styling */
        .performance-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
    
        .performance-box {
            flex: 1;
            padding: 5px;
            margin: 0 5px;
            border: 1px solid #ddd;
            font-size: 12px;
            text-align: center;
        }
    
        .performance-box.best {
            background-color: #c8e6c9;
        }
    
        .performance-box.good {
            background-color: #bbdefb;
        }
    
        .performance-box.average {
            background-color: #ffe0b2;
        }
    }
    
      
        .salary_input{
            padding: 5px;
            width: 70px;
        }
        .plotname{
            font-size: x-small;
        font-weight: 200;
        background: yellow;
        padding: 0px 2px;
        border-radius: 10px;
        }
    
        .performance-container {
          display: flex;
          gap: 20px;
        }
        .performance-box {
          padding: 1px;
          border-radius: 8px;
          color: white;
          text-align: center;
          font-weight: bold;
          width: 80px;
        }
        
        .Best1 {
          background-color: green;
        }
        .Good1 {
          background-color: blue;
        }
        .Average1 {
          background-color: orange;
        }
    
        .best {
      color: green;
    }
    .good {
      color: blue;
    }
    .average {
      color: orange;
    }
    </style>
    










<style>



@media print {
    button, select, input, h2, .header_class, .header, .card-title,select,label,.select2 {
        display: none !important;
    }
    .printfix{
        display: block !important;
    }

}
.printfix{
    display: none ;
}
    .suggestions-list{
    line-height: 16px;
    background: bisque;
    padding: 10px;
}
.suggestions-list li{
    padding-top: 5px;
    border-bottom: 0.5px solid gray;
}

.color{
      background-color:rgb(246, 232, 83);
}
</style>